<template>
  <div class="welcome wbg">
    <div class="top" v-if='$common.AUTH("loan:lists")'>
      <a-row class="row" :gutter="40">
        <a-col :span="5" class="flex">
          <label style="width: 90px;text-align: right;">债务人：</label>
          <a-input placeholder='请输入债务人姓名' v-model='form.debtor'> </a-input>
        </a-col>
        <a-col :span="7" class="flex">
          <label>债务人证件号码：</label>
          <a-input placeholder='请输入债务人证件号码' v-model='form.chinaid'> </a-input>
        </a-col>
        <a-col :span="6" class="flex">
          <label>原告：</label>
          <a-select v-model="form.accuser_id" placeholder="请选择" class="select" mode="multiple" :maxTagCount='1'
            :maxTagTextLength='12' @change="ckAcc" :filter-option="$common.filterOption">
            <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id">{{ item.title
            }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" class="flex">
          <label>业务来源：</label>
          <a-select v-model="form.team_id" placeholder="请选择" class="select">
            <a-select-option value="">全部</a-select-option>
            <a-select-option v-for="item in teamList" :key="item.team.title" :value="item.team_id">{{ item.team.title
            }}</a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row class="row" :gutter="40">
        <a-col :span="5" class="flex">
          <label>还款状态：</label>
          <a-select class="select" v-model='form.status' placeholder="请选择">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">待还款</a-select-option>
            <a-select-option :value="2">已还款</a-select-option>
            <a-select-option :value="3">已逾期</a-select-option>
            <a-select-option :value="4">已申请执行</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="7" class="flex">
          <label style="width: 145px;text-align: right;">录入日期：</label>
          <timePick @PickTime="PickTime" ref="timePicker"></timePick>
        </a-col>
        <a-col :span="8" class="flex">
          <a-button icon="search" type="primary" @click='form.page = 1; query()'
            style="margin-right:20px;height:32px;">查询</a-button>
          <a-button @click='reset' style="margin-right:20px;height:32px;">重置</a-button>
          <!-- <a-button v-if="$common.AUTH('1-1-3')" icon="upload" @click="download()" type="primary" ghost>导出</a-button> -->
          <router-link v-if="$common.AUTH('credit:loan:add')" :to='{ "name": "paybackDetails", params: { id: 0 } }'>
            <a-button type="primary" icon='plus' ghost style="height:32px;">新增</a-button>
          </router-link>
        </a-col>
      </a-row>
    </div>
    <div class="tableList" v-if='$common.AUTH("loan:lists")'>
      <div class="table">
        <table>
          <thead class="thead">
            <td width='80'>序号</td>
            <td width='72'>债务人</td>
            <td width='156'>债务人证件号码</td>
            <td width='100'>所属案件</td>
            <td width='244'>原告</td>
            <td width='212'>案号</td>
            <td width='114'>还款总金额</td>
            <td width='110'>还款状态</td>
            <td width='108'>录入日期</td>
            <!-- <td width='46'>操作</td> -->
          </thead>
          <tbody>
            <tr v-for='(i, index) in list' :key='i.id'>
              <td>{{ 10 * (form.page - 1) + index + 1 }}</td>
              <td><span class="curpoter" @click='dbclick(i)'> {{ i.realname }}</span></td>
              <td>{{ i.chinaid }}</td>
              <td>
                <p v-for='(j,index) in i.cause' :key="index">案件{{ j.sort }}</p>
              </td>
              <td>
                <p v-for='(j,index) in i.cause' :key="index">{{ j.accuser.title }}</p>
              </td>
              <td>
                <p v-for='(j,index) in i.cause' :key="index">{{ j.no || "/" }}</p>
              </td>
              <td>
                <p v-for='(j,index) in i.cause' :key="index">{{ j.loan_one.total | showYuan }}</p>
              </td>
              <td>
                <p v-for='(j,index) in i.cause' :key="index" v-html='status(j.loan_one.status)'></p>
              </td>
              <td style='padding-right:20px;'>
                <p v-for='(j,index) in i.cause' :key="index">{{ j.first_loan.create_time | yearFormat }}</p>
              </td>
              <!-- <td>
                <router-link v-if="$common.AUTH('B1')" :to="{ name: 'paybacksee', params: { id: i.id } }" target='_blank'>查看</router-link>
              <a-button type='link' style="padding:0;">查看</a-button>
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pages">
        <a-pagination v-model="form.page" show-quick-jumper :total="total" show-less-items :pageSize='10'
          @change='turnpage' :show-total="total => `债务人：${total}  案件数：${cause_count}`" />
      </div>
    </div>
    <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
  </div>
</template>
<script>
import { Tacitly } from '@/assets/js/Tacitly'
import { ngetlist } from "@/server/loan"
import { getAccuserAll } from "@/server/api"
export default {
  data() {
    return {
      accuserList: [],
      list: [],        //项目列表
      time: null,
      total: 0,
      cause_count: 0,
      form: {
        accuser_id: [],
        team_id: "",
        limit: 10,
        page: 1,
        chinaid: '',
        stime: '',
        etime: '',
        debtor: '',
        status: ''
      },
    }
  },
  computed: {
    teamList() {
      return this.form.accuser_id.length > 1 || this.form.accuser_id.length == 0 ? [] : this.accuserList.find(ele => {
        return ele.id === this.form.accuser_id[0]
      }).team
    }
  },
  mounted() {
    let _this = this
    document.onkeydown = function (e) {
      // console.log(e)
      if (e.keyCode == 13) {
        _this.query()
      }
    }
  },
  created() {
    getAccuserAll().then((res) => {
      this.accuserList = res.list
    })
    this.query()
  },
  methods: {
    status(val) {
      if (val) {
        const nstatus = {
          '1': {
            name: '待还款',
            color: '#FFB600'
          },
          '2': {
            name: '已还款',
            color: '#12B216'
          },
          '3': {
            name: '已逾期',
            color: '#FF2C2C'
          },
          '4': {
            name: '已申请执行',
            color: '#1266FF'
          }
        }
        return `<font color="` + nstatus[val].color + `">${nstatus[val].name}</font>`
      } else {
        return ""
      }
    },
    turnpage(val) {
      this.form.page = val;
      this.query()
    },
    reset(){
      this.form.limit = 10
      this.form.page = 1
      this.form.debtor = ''
      this.form.chinaid = ''
      this.form.accuser_id = []
      this.form.team_id = ''
      this.form.status = ''
      this.form.stime = ''
      this.form.etime = ''
      this.$refs.timePicker.clearTime()
      this.query()
    },
    query() {
      const form = JSON.parse(JSON.stringify(this.form))
      form.accuser_id = form.accuser_id.toString()
      ngetlist(form).then(e => {
        this.cause_count = e.cause_count
        this.list = e.list
        this.total = e.count
      })
    },
    ckAcc(val) {
      if (val.length > 1 || val.length == 0) {
        this.form.team_id = ''
      }
    },
    dbclick(record) {
      if (this.$common.AUTH('loan:info:lists')) {
        let routeUrl = this.$router.resolve({ "name": "paybacksee", params: { "id": record.id } });
        window.open(routeUrl.href, '_blank');
      }
      else {
        this.$message.error({ content: '暂无权限', key: 'updatable' });
      }
    },
    PickTime(e) {
      if ("stime" in e) {
        this.form.stime = e.stime
      }
      else {
        this.form.etime = e.etime
      }
    },
    download() {
      let http = Tacitly.Base_Port
      this.$modal.confirm({
        content: '确认导出这个文件？',
        onOk: () => {
          window.open(http + 'export/fqhk?accuser_id=' + this.form.accuser_id + '&debtor=' + (this.form.debtor ? this.form.debtor : '') + '&stime=' + (this.form.stime ? this.form.stime : '') + '&etime=' + (this.form.etime ? this.form.etime : '') + '&team_id=' + this.form.team_id)
        }
      })
    }
  }
}
</script>
<style lang="less">
.bigerSta {
  .ant-statistic-content-value-int {
    font-size: 18px;
  }
}
</style>
<style lang="less" scoped>
.welcome {
  position: relative;

  .top {
    @import url('@/assets/css/search.less');
  }

  .tableList {
    margin-top: 20px;
    width: 100%;

    .table {
      thead {
        td {
          padding-left: 0;

          &:nth-child(1) {
            padding-left: 20px;
          }
        }
      }

      tbody {
        tr:nth-last-child(1) {
          border-bottom: 1px solid #ebebeb;
        }

        td {
          padding: 6px 0;
          height: 60px;

          &:nth-child(1) {
            padding-left: 20px;
          }

          p {
            padding: 10px 0;
            margin: 0;
            border-bottom: 1px solid #ebebeb;

            &:nth-last-child(1) {
              border: 0 none;
            }
          }
        }
      }
    }
  }

  .static {
    padding: 20px 0;
    background: #f3f6fb;
    margin: 20px 30px;

    .ul {
      display: flex;
      flex-wrap: wrap;

      &:nth-child(1) {
        padding-bottom: 14px;
        border-bottom: 1px solid #dbdcde;
        margin-bottom: 20px;

        .li {
          margin-bottom: 16px;
        }
      }

      .li {
        width: 20%;
        padding-left: 60px;
        font-size: 14px;
        color: #66707c;
        line-height: 24px;

        b {
          font-size: 20px;
          color: #0e2949;
        }
      }
    }
  }

  .list {
    background: #fff;
    margin-top: 10px;
    overflow: hidden;
  }

  .pages {
    text-align: right;
  }
}
</style>